import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@paypalcorp/pp-react';

var CAMPAIGN_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT'
};
function getBadgeDisplayAttributes(endTime, currentTime, content) {
  var type = 'warning';
  var oneDay = 1000 * 60 * 60 * 24;
  var daysBetween = Math.round(Math.abs((endTime - currentTime) / oneDay));
  var timeDifference = endTime.getTime() - currentTime.getTime();
  var hoursBetween = Math.round(timeDifference / (1000 * 60 * 60));
  var minutesBetween = Math.floor(Math.abs(timeDifference / (1000 * 60)));
  var yearsBetween = Math.round(Math.abs(endTime.getFullYear() - currentTime.getFullYear()));
  var duration = daysBetween;
  var unit = daysBetween > 1 ? getContent(content, 'days') : getContent(content, 'day');
  if (daysBetween > 365) {
    duration = yearsBetween;
    unit = yearsBetween > 1 ? getContent(content, 'years') : getContent(content, 'year');
    type = 'warning';
  } else if (daysBetween > 61 && daysBetween <= 365) {
    var monthsBetween = Math.floor(daysBetween / 30);
    duration = monthsBetween;
    unit = monthsBetween > 1 ? getContent(content, 'months') : getContent(content, 'month');
    type = 'warning';
  } else if (hoursBetween <= 24 && hoursBetween >= 1) {
    duration = hoursBetween;
    unit = hoursBetween > 1 ? getContent(content, 'hours') : getContent(content, 'hour');
    type = 'critical';
  } else if (hoursBetween <= 1 && hoursBetween >= 0) {
    duration = minutesBetween;
    unit = minutesBetween > 1 ? getContent(content, 'minutes') : getContent(content, 'minute');
    type = 'critical';
  }
  return {
    duration: duration,
    unit: unit,
    type: type
  };
}

/**
 * Function that gets content from an object of translated strings to avoid errors or undefined values in case the object is not provided
 * @param {object} content translated strings
 * @param {string} key key to obtain the value of a translated string
 * @returns The content from the provided object or an empty string
 */
function getContent(content, key) {
  if (content && content[key]) {
    return content[key];
  }
  return '';
}
function isEmptyValue(value) {
  return value === undefined || value === null || value === '';
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.valueOf());
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var EndDateBadge = function EndDateBadge(_ref) {
  var content = _ref.content,
    className = _ref.className,
    type = _ref.type;
  var classObj = className ? {
    className: className
  } : {};
  return /*#__PURE__*/React.createElement(Badge, _extends({
    type: type
  }, classObj), content);
};
EndDateBadge.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.string
};

function AdvancedEndDateBadge(_ref) {
  var content = _ref.content,
    endTime = _ref.endTime,
    campaignStatus = _ref.campaignStatus,
    currentTime = _ref.currentTime,
    formatDate = _ref.formatDate;
  var isValidEndTime = !isEmptyValue(endTime === null || endTime === void 0 ? void 0 : endTime.toString()) && isValidDate(endTime);
  var hasEnded = isValidEndTime && endTime.getTime() - currentTime.getTime() <= 0;
  var showEndDateBadge = isValidEndTime && (campaignStatus === CAMPAIGN_STATUS.ACTIVE || campaignStatus === CAMPAIGN_STATUS.DRAFT);
  var displayAttributes = {};
  var endDateContent = '';
  if (showEndDateBadge && !hasEnded) {
    displayAttributes = getBadgeDisplayAttributes(endTime, currentTime, content);
    endDateContent = getContent(content, 'endsInContent').replace('{duration}', displayAttributes.duration).replace('{unit}', displayAttributes.unit);
  } else if (showEndDateBadge && hasEnded) {
    displayAttributes = {
      type: 'neutral'
    };
    endDateContent = getContent(content, 'endedContent').replace('{date}', formatDate(endTime));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, showEndDateBadge && /*#__PURE__*/React.createElement(EndDateBadge, {
    type: displayAttributes.type,
    content: endDateContent
  }));
}
AdvancedEndDateBadge.propTypes = {
  content: PropTypes.object,
  endTime: PropTypes.instanceOf(Date),
  campaignStatus: PropTypes.string,
  currentTime: PropTypes.instanceOf(Date),
  formatDate: PropTypes.func
};

export { AdvancedEndDateBadge };
